import FindLangKey from 'Global/Functions/FindLangKey/FindLangKey';

export const labels = () => {
  const _label_reset_password =  FindLangKey('web-app-settings-reset-password');
  const _label_login_by_phone = FindLangKey('web-app-settings-login-by-phone-number');
  const _label_name_markaz =  FindLangKey('general-settings-name-markaz');
  const _label_tel_markaz =   FindLangKey('general-settings-tel-markaz');
  const _label_address_markaz = FindLangKey('general-settings-address-markaz');
  const _label_logo_markaz =  FindLangKey('general-settings-logo-markaz');
  const _label_color_default = FindLangKey('general-settings-color-default');
  const _label_color_org = FindLangKey('general-settings-color-organization');
  const _label_default_lang =FindLangKey('general-settings-default-language');
  const _label_enmad_link = FindLangKey('general-settings-enamad-link');
  
 
  
  const data = [
     {
        key:'webAppFaramoshiRamz',
        value:_label_reset_password
     },
     {
        key:'webAppLoginByMobile',
        value:_label_login_by_phone
     },
     {
      key:'webAppNameMarkaz',
      value:_label_name_markaz
     },
     {
      key:'webAppTelMarkaz',
      value:_label_tel_markaz
     },
     {
      key:'webAppAddressMarkaz',
      value:_label_address_markaz
     },
     {
      key:'WebAppEnamadURL',
      value:_label_enmad_link
     },
     {
      key:'webAppLogo',
      value:_label_logo_markaz
     },
     {
      key:'webAppColorDefault',
      value:_label_color_default
     },
     {
      key:'webAppColorOrg',
      value:_label_color_org
     },
     {
      key:'webAppLangDefault',
      value:_label_default_lang
     }
  ];
  return data;
};
